import { StyledIcon } from '@/components/icons/StyledIcon';
import { colorPalettes } from '@/context/theme';
import { styled } from '@mui/material';

interface CustomStyledCheckboxProps {
  disabled?: boolean;
}

export const StyledCheckbox = styled('span')<CustomStyledCheckboxProps>`
  height: 14px;
  width: 14px;
  background-color: ${({ theme, disabled }) =>
    colorPalettes[theme.palette.mode].components.checkbox[
      disabled ? 'disabled' : 'enabled'
    ].background};
  border: 1px solid ${({ disabled, theme }) =>
    colorPalettes[theme.palette.mode].components.checkbox[
      disabled ? 'disabled' : 'enabled'
    ].border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ disabled, theme }) =>
      colorPalettes[theme.palette.mode].components.checkbox[
        disabled ? 'disabled' : 'enabled'
      ].hover.background}
  }

  ${String(StyledIcon)} {
    color: ${({ disabled, theme }) =>
      colorPalettes[theme.palette.mode].components.checkbox[
        disabled ? 'disabled' : 'enabled'
      ].color}}
  }
`;

export const StyledLabel = styled('label')<CustomStyledCheckboxProps>`
  font-size: 1.0769rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.7692rem;

  &:hover {
    ${String(StyledCheckbox)} {
      background-color: ${({ disabled, theme }) =>
        colorPalettes[theme.palette.mode].components.checkbox[
          disabled ? 'disabled' : 'enabled'
        ].hover.background};
    }
  }
`;

export const StyledInput = styled('input')`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
